module.exports = __webpack_public_path__ + "static/media/icon_collaboration_innovation.4d893450.svg";